import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    { path: '/', redirect: '/home' },
    {
        path: '/home',
        component: () => import('@/views/Home.vue'),
        meta: {
            title: '首页 - 恒一智行',
            description: '恒一智行官网首页，提供企业AI解决方案'
        },
        children: [
            {
                path: '',
                component: () => import('@/views/FirstPage.vue')
            },
            {
                path: 'ai-app',
                component: () => import('@/views/AiApp.vue')
            },
            {
                path: 'custom-dev',
                component: () => import('@/views/Custom.vue')
            },
            {
                path: 'about',
                component: () => import('@/views/About.vue')
            },
            {
                path: 'trial',
                component: () => import('@/views/Trial.vue')
            }
        ]
    },
    {
        path: '/login',
        component: () => import('@/views/Login.vue'),
        meta: {
            title: '登录 - 恒一智行'
        }
    },
    { path: '/trial', component: () => import('@/views/Trial.vue') },

    // 智能体
    {
        path: '/intelligence',
        component: () => import('@/views/intelligence.vue'),
        meta: {
            title: '智能体 - 恒一智行'
        }
    },
    // 定制方案
    {
        path: '/solution',
        component: () => import('@/views/Solution.vue'),
        meta: {
            title: '智能体 - 恒一智行'
        }
    },
    // 业务详情
    {
        path: '/business/:id',
        component: () => import('@/views/BusinessDetail.vue'),
        meta: {
            title: '业务详情 - 恒一智行'
        }
    },
    // 解决方案详情
    {
        path: '/solution/detail',
        component: () => import('@/views/SolutionDetail.vue'),
        meta: {
            title: '解决方案详情 - 恒一智行'
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

export default router
